import { Tip } from "@/constants/tip";
import { getTipThumbnailSrc } from "@/utils/guidebook/getTipTumbnailSrc";
import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { HStack, NextLink, Image, colors } from "goi_common";
import { Category } from "@/types/guidebookType";

interface GuidebookProps {
  tags: any[];
  category: Category;
  id: number | string;
  item: Tip;
  to: string;
  onClick?: () => void;
  keyword?: string;
}
export const GuidebookThumbnail = ({
  tags,
  category,
  id,
  item,
  to,
  keyword,
  onClick,
}: GuidebookProps) => {
  return (
    <NextLink href={to} onClick={onClick}>
      <Box marginBottom="40px">
        <ImageContainer>
          <Box
            backgroundImage={`${process.env.NEXT_PUBLIC_CDN_URL}${getTipThumbnailSrc(
              category,
              id,
            )}`}
            backgroundSize="cover"
            backgroundRepeat="no-repeat"
            backgroundPosition="center"
            width="100%"
            height="100%"
            borderRadius="8px"
          />
        </ImageContainer>
        <Box
          marginTop="12px"
          className="subtitle2_b gray900"
          dangerouslySetInnerHTML={{
            __html: keyword
              ? item.title.replaceAll(keyword, `<span class="orange650">${keyword}</span>`)
              : item.title,
          }}
        />

        <Box marginTop="12px" className="caption1 gray500">
          {tags.find((tag) => category.includes(tag.value))?.key} | {item.tag} | {item.date}
        </Box>
      </Box>
    </NextLink>
  );
};

interface GuidebookRowThumbnailProps {
  id: number | string;
  item: Tip;
  to: string;
  category: Category;
  onClick?: () => void;
}
export const GuidebookRowThumbnail = ({
  category,
  id,
  item,
  to,
  onClick,
}: GuidebookRowThumbnailProps) => {
  const { title, tag } = item;

  return (
    <NextLink
      href={to}
      onClick={onClick}
      css={{ padding: "16px 0", borderBottom: `1px solid ${colors.gray300}` }}
    >
      <HStack gap={14} justifyContent="space-between">
        <h4 className="body_16_m">{title}</h4>
        <Image
          width={133}
          height={84}
          src={`${process.env.NEXT_PUBLIC_CDN_URL}${getTipThumbnailSrc(category, id)}`}
          alt={tag || ""}
        />
      </HStack>
    </NextLink>
  );
};

const ImageContainer = styled.div`
  aspect-ratio: 3/2;
`;
